import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, createBlock as _createBlock, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "article"
};
const _hoisted_2 = ["innerHTML"];
import { onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { useAppState } from '@/composables/useAppState';
import { useAuth } from '@/composables/useAuth';
import { useContent } from '@/composables/useContent';
import ChatMgButton from './elements/ChatMgButton.vue';
import CustomerLoadWait from './elements/CustomerLoadWait.vue';
import HeaderBlock from './elements/HeaderBlock.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'ArticlePage',
    setup(__props) {
        const route = useRoute();
        const state = useAppState();
        useAuth();
        const { getCmsArticle } = useContent();
        onMounted(() => {
            getCmsArticle(route.params.id);
        });
        return (_ctx, _cache) => {
            const _component_v_chip = _resolveComponent("v-chip");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(HeaderBlock, {
                    title: "",
                    bgcolor: "transparent",
                    border: "0"
                }),
                _createVNode(CustomerLoadWait, {
                    customer: _unref(state).article
                }, null, 8, ["customer"]),
                _createVNode(_Transition, null, {
                    default: _withCtx(() => [
                        (_unref(state).article)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                                _createElementVNode("div", {
                                    class: "articleImg",
                                    style: _normalizeStyle('background-image: url(' + _unref(state).article.image + ')')
                                }, null, 4),
                                _createElementVNode("h1", null, _toDisplayString(_unref(state).article.title), 1),
                                _createElementVNode("p", null, [
                                    _createVNode(_component_v_chip, {
                                        variant: "outlined",
                                        size: "small"
                                    }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_unref(state).article.tagsArray[0]), 1)
                                        ]),
                                        _: 1
                                    })
                                ]),
                                _createElementVNode("p", {
                                    innerHTML: _unref(state).article.body.replaceAll('</h2>\n\n', '</h2>\n').replaceAll('\n', '<br/>').replaceAll('<a href=', '<a style=\'text-decoration:underline\' href=')
                                }, null, 8, _hoisted_2)
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                }),
                (_unref(state).article)
                    ? (_openBlock(), _createBlock(ChatMgButton, {
                        key: 0,
                        hover: true,
                        icon: require('@/assets/ai.png'),
                        prompt: 'Summarise this article in one very short paragraph, use emojis: ' + _unref(state).article.body,
                        bottom: "10%"
                    }, null, 8, ["icon", "prompt"]))
                    : _createCommentVNode("", true)
            ], 64));
        };
    }
});
